import {
  PATH_FOLDER_DEFAULT,
  PATH_FOLDER_MISSIONS,
  PATH_FOLDERS_DEFAULT,
  PATH_MISSION_DEFAULT,
  PATH_MISSION_SUB_MISSIONS,
} from '../app/constants/paths.constant';
import { MissionSpaceEnum } from '../app/enums/mission-space.enum';
import { MISSION_SPACE_PARAM } from '../app/utils/mission-space.util';
import {
  buildMissionBreadcrumbPaths,
  resolvePageMissionKind,
} from '../app/utils/mission-page-naming.util';
import { useMissionContext } from '../contexts/MissionContext/hooks/useMissionContext.hook';
import type { BreadcrumbPath } from '../components/Breadcrumbs';

import { useBuildPaths } from './useBuildPaths.hook';
import { useMissionSpace } from './useMissionSpace.hook';

// The breadcrumb of the current mission page, up to its mission.
export const useMissionBreadcrumbPaths = (): readonly BreadcrumbPath[] => {
  const { folderId, missionId, mission } = useMissionContext();
  const space = useMissionSpace();

  const { paths } = useBuildPaths(
    {
      folder: PATH_FOLDER_DEFAULT,
      folderMissions: PATH_FOLDER_MISSIONS,
      mission: PATH_MISSION_DEFAULT,
    },
    { folderId, missionId },
  );
  const { paths: collaborationPaths } = useBuildPaths(
    {
      collaboration: PATH_MISSION_DEFAULT,
      collaborationSubMissions: PATH_MISSION_SUB_MISSIONS,
    },
    {
      folderId,
      missionId: mission?.compositeMissionId ?? undefined,
      [MISSION_SPACE_PARAM]: MissionSpaceEnum.Collaborations,
    },
  );

  return buildMissionBreadcrumbPaths({
    kind: resolvePageMissionKind(mission?.kind, space),
    paths: {
      folders: PATH_FOLDERS_DEFAULT,
      ...paths,
      ...(mission?.compositeMissionId ? collaborationPaths : {}),
    },
  });
};
